window.__filename = window.__filename || '';
window.__dirname = window.__dirname || '';

// import './index.css'
// import App from './App'
// import { Provider } from 'react-redux'
// import ReactDOM from 'react-dom/client'
// // import reportWebVitals from './reportWebVitals'
// import store from 'shared-ui/redux/store'

// const root = ReactDOM.createRoot(document.getElementById('root'))
// root.render(
//     <Provider store={store}>
//         <App />
//     </Provider>
// )

// // If you want to start measuring performance in your app, pass a function
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// // reportWebVitals()

import './index.css'
import App from './App'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { Suspense } from 'react'
import store from 'shared-ui/redux/store'
import ErrorBoundary from "./ErrorBoundary";
import * as Sentry from "@sentry/react";
import { getEnv } from './utils/env'
import { isChunkLoadError, reloadForChunkError } from './utils/chunkReload'
import { initClarity } from 'shared-ui/utils/clarity'


const sentryDsn = getEnv("SENTRY_DSN");
const parseBoolean = (value, fallback) => {
  if (value === undefined || value === null || value === "") return fallback;
  return String(value).toLowerCase() === "true";
};
const parseNumber = (value, fallback) => {
  if (value === undefined || value === null || value === "") return fallback;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const isSentryEnabled = parseBoolean(getEnv("ENABLE_SENTRY"), true);
const isTracingEnabled = parseBoolean(getEnv("SENTRY_ENABLE_TRACING"), true);
const tracesSampleRate = parseNumber(getEnv("SENTRY_TRACES_SAMPLE_RATE"), 0);

if (sentryDsn && isSentryEnabled) {
  Sentry.init({
    dsn: sentryDsn,
    sampleRate: parseNumber(getEnv("SENTRY_SAMPLE_RATE"), 1),
    attachStacktrace: parseBoolean(getEnv("ENTRY_ATTACH_STACKTRACE"), true),
    tracesSampleRate: isTracingEnabled ? tracesSampleRate : 0,
    profilesSampleRate: parseNumber(getEnv("SENTRY_PROFILES_SAMPLE_RATE"), 0),
    debug: parseBoolean(getEnv("SENTRY_DEBUG"), false),
    maxBreadcrumbs: parseNumber(getEnv("SENTRY_MAX_BREADCRUMBS"), 100),
    sendDefaultPii: parseBoolean(getEnv("SENTRY_SEND_DEFAULT_PII"), true),
    shutdownTimeout: parseNumber(getEnv("SENTRY_SHUTDOWN_TIMEOUT"), 2000),
    ignoreErrors: getEnv("SENTRY_IGNORE_ERRORS").split(",") || [],
  });
}

if (getEnv("ENV") === "production") {
  initClarity();
}


/**************************************
 * CHUNK ERROR HANDLERS
 * Catch chunk failures outside React (dynamic imports not rendered via
 * React.lazy). Lazy route failures are handled in ErrorBoundary.
 **************************************/
window.addEventListener("error", (e) => {
  if (
    e.message?.includes("ChunkLoadError") ||
    e.message?.includes("Loading chunk")
  ) {
    Sentry.captureException(e.error || e)
    reloadForChunkError();
  }
});

window.addEventListener("unhandledrejection", (e) => {
  if (isChunkLoadError(e.reason)) {
    Sentry.captureException(e.reason)
    reloadForChunkError();
  }
});

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <ErrorBoundary>
    <Suspense fallback={<div>Loading app…</div>}>
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
  </ErrorBoundary>
);